import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChoiceOption, SingleChoiceQuestion } from '../profile-question.model';

/** How long the picked option shows as selected before the answer is sent. */
const CONFIRM_DELAY_MS = 250;

/** Figma: IVY-HA 235:19023 (desktop) / 235:18939 (mobile). No NEXT button: tapping an option answers. */
@Component({
  selector: 'app-single-choice-question',
  standalone: true,
  imports: [NgClass, NgFor, NgIf],
  template: `
    <div class="flex flex-col items-center gap-[38px]">
      <h2 class="max-w-[275px] text-center text-2xl font-bold leading-[30px] md:max-w-none">{{ question.title }}</h2>

      <div class="flex w-full flex-col gap-3" role="radiogroup" [attr.aria-label]="question.title">
        <button
          *ngFor="let option of question.options"
          type="button"
          role="radio"
          [attr.aria-checked]="selected === option.value"
          class="flex w-full items-center justify-center rounded px-4 py-5 text-center text-base leading-6 md:px-12"
          [ngClass]="selected === option.value ? 'bg-[#B6A8F7] font-bold' : 'border border-black bg-white'"
          [disabled]="selected !== null"
          (click)="pick(option)"
        >{{ option.label }}</button>

        <p *ngIf="question.note" class="rounded bg-white p-4 text-sm italic leading-5">{{ question.note }}</p>
      </div>
    </div>
  `
})
export class SingleChoiceQuestionComponent {
  @Input({ required: true }) question!: SingleChoiceQuestion;
  @Output() answer = new EventEmitter<string>();

  selected: string | null = null;

  pick(option: ChoiceOption) {
    this.selected = option.value;
    setTimeout(() => this.answer.emit(option.value), CONFIRM_DELAY_MS);
  }
}
